import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { UiBackBreadCrumb } from "../../../_uiComponents/UiBackBreadCrumb";
import { UiButton } from "../../common/UiButton";
import {
  notificationDetailClear,
  notificationListRequest,
  notificationUnreadCountRequest,
} from "../../../../_redux/_actions";
import { useNavigate } from "react-router-dom";
import { showCustomLoading } from "../../../../_helpers/support.services";
import { openSafeExternalUrl } from "../../../../_helpers/safeExternalUrl.helper";
import {
  notificationConstants,
  commonConstants,
} from "../../../../_redux/_constants";
import { UiGrayBgLoader } from "../../common/UiGrayBgLoader";

export const UiNotificationView = ({
  id,
  selectedId,
  onClick,
  showNotification,
}) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { notificationDetails } = useSelector((state) => ({
    notificationDetails: state.notification?.notificationDetails || {},
  }));

  const template = notificationDetails?.notificationTemplate;
  const linkType = template?.linkType?.name;
  const moreInfoLink = template?.moreInfoWebLink;

  const { loader } = useSelector((state) => {
    return {
      loader: state.loading,
    };
  });

  const goBack = () => {
    const payload = {
      locale: i18n.language,
      landingType: notificationConstants.NOTIFICATION_LANDING_TYPE,
      setToZero: notificationConstants.NOTIFICATION_SET_TO_ZERO,
      pageStart: commonConstants.PAGE_START,
      pageEnd: commonConstants.NOTIFICATION_LIST_PAGE_END,
    };
    dispatch(notificationListRequest(payload));
    dispatch(notificationDetailClear());
    dispatch(notificationUnreadCountRequest({ locale: i18n.language }));
    onClick();
  };

  if (
    linkType &&
    linkType !== notificationConstants.NOTIFICATION_LINK_TYPE_NEW_DETAIL_SCREEN
  ) {
    return null;
  }

  return (
    <div className="df-notification-view">
      <div className="df-notification-view__header">
        <UiBackBreadCrumb
          titleText={t("Details")}
          disableCloseButton
          backOnClick={goBack}
        />
      </div>

      {showCustomLoading(
        [notificationConstants.NOTIFICATION_DETAIL_REQUEST],
        loader?.pendingRequests,
      ) ? (
        <UiGrayBgLoader className="df-ch-130" />
      ) : (
        <div className="df-notification-view__body">
          <img
            src={
              notificationDetails?.notificationTemplate?.detailImage &&
              process.env.NFS_PUBLIC_IMAGE_URL +
                process.env.PUBLIC_STATIC_IMAGE_URL +
                notificationDetails?.notificationTemplate?.detailImage
            }
            className="w-100"
          />
          <h2>{notificationDetails?.notificationTemplate?.detailTitle}</h2>
          <p>{notificationDetails?.notificationTemplate?.detailDescription}</p>
        </div>
      )}

      {linkType ===
        notificationConstants.NOTIFICATION_LINK_TYPE_NEW_DETAIL_SCREEN &&
        moreInfoLink && (
          <div className="df-notification-view__footer">
            <UiButton
              className="df-ui-dark-bg-btn w-100 mt-2"
              name={t("Learn More")}
              onClick={() =>
                openSafeExternalUrl(
                  moreInfoLink,
                  notificationConstants.NOTIFICATION_DETAIL_NEW_TAB,
                )
              }
            />
          </div>
        )}
    </div>
  );
};
